const eventMap = new Map();

export function publish(event) {
    let eventName = event.constructor.name;
    if (eventName && eventMap.has(eventName)) {
        eventMap.get(eventName).forEach((listener) => listener(event.args));
    }
}

export function subscribe(eventClass, listener) {
    let eventName = eventClass.name;
    if (!eventMap.has(eventName)) {
        eventMap.set(eventName, new Set());
    }
    eventMap.get(eventName).add(listener);

    return {
        unsubscribe: function unsubscribe() {
            eventMap.get(eventName).delete(listener);
        }
    };
}
